<template>
 <div v-if="view">
<h3 class="text-center">{{computeCaption(fields_en['pay_my_bills'], $store.state.lang.value.toLowerCase())}}</h3><br>
 <div class="col-md-8 col-md-offset-2">
    <div class="general-active-section">
    <br>
      <div class="row">
      <div class="col-md-7 col-xs-6 col-sm-6" :class="isMobile() ? '' : 'ml-30'">
        {{computeCaption(fields_en['select_claim'], $store.state.lang.value.toLowerCase())}}
      </div>
      <div class="col-md-4 col-xs-6 col-sm-6">
      <div class="float-right">
        <el-radio-group size="small" placeholder="Single Select" v-model="paid">
          <el-radio-button
          label="Unpaid"
          value="Unpaid"
          tabindex=0
          :disabled="disabled">
          {{computeCaption(fields_en['unpaid'], $store.state.lang.value.toLowerCase())}}
          </el-radio-button>
          <el-radio-button
            label="Paid"
            value="Paid"
            tabindex=0
            :disabled="disabled">
            {{computeCaption(fields_en['paid'], $store.state.lang.value.toLowerCase())}}
          </el-radio-button>
        </el-radio-group>
        </div>
      </div>
        </div>
        <br>
      </div>
    </div>
 <div class="col-md-8 col-md-offset-2">
      <div class="general-active-section">
      <br>
      <div v-for="claim in filteredClaims" class="pt-7">
        <div>
          <div class="bg-color p-10 rounded ml-10 mr-10" :class="claim.selected ? 'selected' : ''">
            <div class="row">
            <div :class="isMobile() ? 'row ml-5' : ''">
              <div :class="isMobile() ? 'col-xs-6 col-sm-6' : 'col-md-6'">
                <div :class="isMobile() ? 'pt-10 ml-10' : 'pt-13 pb-5 ml-25'">
                  <el-checkbox v-model="claim.selected" v-if="paid === 'Unpaid'"><p><span class="fs-17 black" v-if="!isMobile()">{{ claim.id }} </span></p></el-checkbox>
                  <p v-if="paid === 'Paid' && !isMobile()"><span class="fs-17 ml-30">{{ claim.id }} </span></p>
                </div>
              </div>
              <div v-if="isMobile()">
              <div class="col-xs-6 col-sm-6 pt-13">
              <a
                v-if="moreInfoButton !== claim.id"
                @click.stop.prevent="
                  moreInfoButton = claim.id
                "
                class="float-right mr-30"
                ><i class="el-icon-arrow-down icon-button"></i
              ></a>
              <a
                v-if="moreInfoButton === claim.id"
                @click.stop.prevent="moreInfoButton = ''"
                class="float-right mr-30"
                ><i class="el-icon-arrow-up icon-button"></i
              ></a>
            </div>
            </div>
            </div>
              <div :class="isMobile() ? 'row' : ''">
                <div class="col-xs-12 col-sm-12" v-if="isMobile()">
                  <div class="pt-13">
                    <p><span class="float-left ml-25" :class="isMobile() ? 'fs-13' : 'fs-17'">{{ claim.id }} </span><br /></p>
                  </div>
                </div>
                <div class="col-md-3 col-xs-8 col-sm-8">
                  <div :class="isMobile() ? 'pt-15' : 'pt-13'"><p><span class="fs-17" :class="isMobile() ? 'ml-25' : 'ml-10'">
                  {{computeCaption(fields_en['amoount_due'], $store.state.lang.value.toLowerCase())}}:
                  <b>${{claim.amount}}</b></span></p></div>
                </div>
                <div class="text-center col-xs-3 col-sm-3 ml-10" v-if="isMobile()">
                <div class="float-right">
                <span :class="isMobile() ? 'fs-15' : 'fs-20'">{{ claim.day }} </span><br />
                <span :class="isMobile() ? 'fs-10' : 'fs-15'">{{ claim.month }} </span>
              </div>
              </div>
              </div>
              <!-- <div :class="isMobile() ? 'col-xs-1 col-sm-1' : 'col-md-1'">
                <div v-if="claim.paid" class=" pt-10 pb-5">
                  <img src="static/img/paid.png" class="image">
                </div>
                <div v-else>
                  <img src="static/img/unpaid.png" class="image">
                </div>
              </div> -->
              <div v-if="!isMobile()">
              <div class="text-center" :class="isMobile() ? 'col-xs-2 col-sm-2' : 'col-md-2'">
                <div class="float-right">
                <span :class="isMobile() ? 'fs-15' : 'fs-20'">{{ claim.day }} </span><br />
                <span :class="isMobile() ? 'fs-10' : 'fs-15'">{{ claim.month }} </span>
              </div>
              </div>
              </div>
              <div v-if="!isMobile()" class="col-md-1 pt-13 text-center">
              <a
                v-if="moreInfoButton !== claim.id"
                @click.stop.prevent="
                  moreInfoButton = claim.id
                "
                class="turnGreen float-mobile"
                ><i class="el-icon-arrow-down icon-button"></i
              ></a>
              <a
                v-if="moreInfoButton === claim.id"
                @click.stop.prevent="moreInfoButton = ''"
                class="turnGreen float-mobile"
                ><i class="el-icon-arrow-up icon-button"></i
              ></a>
            </div>
            </div>
          </div>
        </div>
         <transition name="fade">
          <div v-if="moreInfoButton === claim.id && claim.details" class="rounded ml-10 mr-10">
            <div :class="isMobile() ? '' : 'pb-7'">
            <div v-for="detail in claim.details" class="pt-7 pb-7">
            <div class="row" :class="isMobile() ? 'ml-5' : 'ml-30'">
              <div class="col-md-3 col-xs-12 col-sm-12">
              {{computeCaption(fields_en['patient'], $store.state.lang.value.toLowerCase())}}: {{detail.patient}}
              </div>
              <div class="col-md-2 col-sm-12 col-xs-12">
              {{computeCaption(fields_en['date_of_service'], $store.state.lang.value.toLowerCase())}}: {{detail.date}}
              </div>
              <div :class="isMobile() ? 'row' : ''">
              <div class="col-md-4 col-xs-6 col-sm-6">
                <div :class="isMobile() ? 'ml-20' : 'ml-85'">
                {{detail.test}}
                </div>
              </div>
              <div class="col-md-1 col-xs-4 col-sm-4" :class="isMobile() ? 'ml-50 text-center' : 'ml-90 text-center'">
                ${{detail.amount}}
              </div>
              </div>
            </div>
            </div>
            <div class="float-right total fs-15" :class="isMobile() ? 'col-xs-12 col-sm-12' : 'mr-100 '">
            {{computeCaption(fields_en['total_amount_due'], $store.state.lang.value.toLowerCase()).toUpperCase()}}: ${{claim.amount}}
            </div>
            </div>
            <br>
          </div>
        </transition>
      </div>
      <br>
      </div>
      <br>
      <div class="row">
        <div class="col-md-10 col-md-offset-1 button-container">
            <button
              class="btn btn-default btn-wd btn-back primary-color back-button"
              v-on:click.stop.prevent="$router.push({ path: '/' })">
              <span> {{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}}</span>
            </button>
            <button
                    class="btn btn-fill btn-wd btn-next float-right next-button"
                    v-on:click.stop.prevent="validate()"
                    :disabled="disabledButton === true"
            >
              <span v-if="disabledButton === false">{{computeCaption(fields_en['pay'], $store.state.lang.value.toLowerCase())}}</span>
              <span v-else>{{computeCaption(fields_en['submitting'], $store.state.lang.value.toLowerCase())}}</span>
            </button>
      </div><br><br>
    </div>
    </div>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
</template>
<script>
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {Input, Checkbox, RadioGroup, Radio, RadioButton} from 'element-ui'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'

  export default {
    components: {
      [Input.name]: Input,
      [Checkbox.name]: Checkbox,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton
    },
    mixins: [TranslationsUtils, ValidationUtils],
    props: {
    },
    data () {
      return {
        disabled: false,
        moreInfoButton: '',
        filteredClaims: [],
        paid: 'Unpaid',
        view: true, // make this false once you have the call for claims
        claims: [],
        disabledButton: false,
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        fields_en: {
          pay: 'Pay',
          back: 'Back',
          pay_my_bills: 'Claims',
          submitting: 'Submitting...Please wait',
          select_claim: 'Select Claim',
          unpaid: 'Unpaid',
          paid: 'Paid',
          amoount_due: 'Amount Due',
          patient: 'Patient',
          date_of_service: 'Date of Service',
          total_amount_due: 'Total Amount Due'
        },
        model: {
        },
        modelValidations: {
        }
      }
    },
    mounted () {
    },
    methods: {
      getClaims (email) {
        axios({
          url: process.env.SERVER_URI + '/getClaims',
          method: 'post',
          data: {email: localStorage.getItem('email')}
        })
        .then((response) => {
          this.claims = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      async validate () {
        await this.makeButtonDisabled()
      },
      makeButtonDisabled () {
        this.disabledButton = true
      },
      redirect () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/' })
          window.location.reload()
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    computed: {
    },
    beforeMount () {
      this.claims = {
        'paid': [
          {
            id: 'Claim3',
            amount: 400,
            paid: true,
            date: '12/10/2022',
            day: 12,
            month: 'January',
            selected: true,
            details: [
              {
                patient: 'John Doe',
                date: '26 dec',
                test: 'Covid',
                amount: 50
              }
            ]
          }
        ],
        'unpaid': [
          {
            id: 'Claim1',
            amount: 250,
            paid: false,
            date: '10/10/2022',
            day: 10,
            month: 'December',
            selected: false,
            details: [
              {
                patient: 'Sonia Matner',
                date: '26 dec',
                test: 'covid',
                amount: 50
              },
              {
                patient: 'Matner Sonia',
                date: '28 dec',
                test: 'pcr',
                amount: 150
              }
            ]
          },
          {
            id: 'Claim2',
            amount: 110,
            paid: false,
            date: '11/10/2022',
            day: 11,
            month: 'December',
            details: [
              {
                patient: 'Sonia Matner',
                date: '26 dec',
                test: 'covid',
                amount: 110
              }
            ]
          }
        ]
      }
      if (this.paid === 'Paid') {
        this.filteredClaims = this.claims['paid']
      } else {
        this.filteredClaims = this.claims['unpaid']
      }
    },
    watch: {
      'paid': {
        handler: function (val) {
          if (this.paid === 'Paid') {
            this.filteredClaims = this.claims['paid']
          } else {
            this.filteredClaims = this.claims['unpaid']
          }
        },
        deep: true
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

.image {
  width: 30px;
  height: 30px;
  padding-top: 0%;
}

.pb-5 {
  padding-bottom: 5px;
}

.pt-7{
  padding-top: 7px;
}

.pt-13{
  padding-top: 13px;
}

.pt-10{
  padding-top: 8px;
}

.pt-15 {
  padding-top: 15px;
}

.p-10 {
  padding-top: 5px;
  padding-bottom: 1px;
  padding-right: 3px;
  padding-left: 3px;
}

.bg-color {
  background-color: white;
}

.rounded {
  border: 1px solid $default-grey;
  border-radius: 3px;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-10 {
  font-size: 10px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.claim {
  text-align: center;
  font-size: 20px;
}

.ml-10 {
  margin-left: 10px;
}

.mr-10 {
  margin-right: 10px;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.selected {
  background: #F5F8FB;
}

.ml-50 {
  margin-left: 50px;
}

.ml-25 {
  margin-left: 25px;
}

.ml-30 {
  margin-left: 30px;
}

.ml-85 {
  margin-left: 85px;
}

.ml-90 {
  margin-left: 90px;
}

.black {
  color: black;
}

.total {
  background: #F1F1F1;
}

.mr-100 {
  margin-right: 125px;
}

.ml-5 {
  margin-left: 5px;
}

.mr-30 {
  margin-right: 30px;
}

.mr-15 {
  margin-right: 15px;
}

.ml-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/PayMyBillsLogged.vue